export const getFilteredQuery = (query = "") => {
    const trimmed = query.trim();
    const lower = trimmed.toLowerCase();

    if (lower === "bd@") return "";
    if (lower.startsWith("bd@")) return trimmed.substring(3).trim();
    return trimmed;
};